export const name = "RPAD";
export const summary = `Appends a \`STRING\` or \`BYTES\` value with a pattern.`;
export const reference = `
## RPAD

Appends a \`STRING\` or \`BYTES\` value with a pattern.

\`\`\`
RPAD(original_value, return_length[, pattern])
\`\`\`

### Description

Returns a \`STRING\` or \`BYTES\` value that consists of \`original_value\` appended with \`pattern\`. The \`return_length\` parameter is an\`INT64\` that specifies the length of the returned value. If \`original_value\` is \`BYTES\`,\`return_length\` is the number of bytes. If \`original_value\` is \`STRING\`,\`return_length\` is the number of characters.

The default value of \`pattern\` is a blank space.

Both \`original_value\` and \`pattern\` must be the same data type.

If \`return_length\` is less than or equal to the \`original_value\` length, this function returns the \`original_value\` value, truncated to the value of\`return_length\`. For example, \`RPAD('hello world', 7);\` returns \`'hello w'\`.

If \`original_value\`, \`return_length\`, or \`pattern\` is \`NULL\`, this function returns \`NULL\`.

This function returns an error if:

- \`return_length\` is negative
- \`pattern\` is empty


### Return type

\`STRING\` or \`BYTES\`


### Examples



\`\`\`
SELECT FORMAT('%T', RPAD('c', 5)) AS results

/*---------*
 | results |
 +---------+
 | "c " |
 *---------*/
\`\`\`



\`\`\`
SELECT RPAD('b', 5, 'a') AS results

/*---------*
 | results |
 +---------+
 | baaaa |
 *---------*/
\`\`\`



\`\`\`
SELECT RPAD('abc', 10, 'ghd') AS results

/*------------*
 | results |
 +------------+
 | abcghdghdg |
 *------------*/
\`\`\`



\`\`\`
SELECT RPAD('abc', 2, 'd') AS results

/*---------*
 | results |
 +---------+
 | ab |
 *---------*/
\`\`\`



\`\`\`
SELECT FORMAT('%T', RPAD(b'abc', 10, b'ghd')) AS results

/*---------------*
 | results |
 +---------------+
 | b"abcghdghdg" |
 *---------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/string_functions
`;
